const time = {
  "周": "주",
  "天": "일",
  "小时": "시간",
  "分钟": "분",
  "刚刚": "방금",
  "前": "전",
  "昨天": "어제",
  "星期一": "월요일",
  "星期二": "화요일",
  "星期三": "수요일",
  "星期四": "목요일",
  "星期五": "금요일",
  "星期六": "토요일",
  "星期日": "일요일",
  "一月": "1월",
  "二月": "2월",
  "三月": "3월",
  "四月": "4월",
  "五月": "5월",
  "六月": "6월",
  "七月": "7월",
  "八月": "8월",
  "九月": "9월",
  "十月": "10월",
  "十一月": "11월",
  "十二月": "12월",
  "一": "월",
  "二": "화",
  "三": "수",
  "四": "목",
  "五": "금",
  "六": "토",
  "日": "일",
}

export default time;
